import {Injectable} from '@angular/core';
import {Http, Headers, Response} from '@angular/http';
import 'rxjs/add/operator/map'
import {Router} from '@angular/router';

@Injectable()
export class AuthenticationService {
    constructor(private http: Http,
                private router: Router) {
    }

    login(username: string, password: string) {
        localStorage.removeItem('currentUser');
        let headers = new Headers();
        headers.append('X-Requested-With', 'XMLHttpRequest');
        headers.append('Content-Type', 'application/json');
        headers.append('Cache-Control', 'no-cache');
        return this.http.post('/api/authenticate', JSON.stringify({
            username: username,
            password: password
        }), {headers: headers})
            .map((response: Response) => {
                let user = response.json();
                console.debug('user', user);
                if (user && user.username) {
                    // store user details in local storage to keep user logged in between page refreshes
                    localStorage.setItem('currentUser', JSON.stringify(user));
                }
            });
    }

    logout(navigate: string, args?: any) {
        localStorage.removeItem('currentUser');
        this.http.post('/user/logout', {}).toPromise().then((response: Response) => {
            this.router.navigate([navigate], args);
        });
    }

    static isLoggedIn() {
        return localStorage.getItem('currentUser') != null;
    }

    static isPermitted(url: string): boolean {
        return AuthenticationService.isLoggedIn();
    }

    static getUser(): any {
        let userString = localStorage.getItem('currentUser');
        if (userString == null) {
            return false;
        }
        return JSON.parse(userString);
    }

    static hasRole(roleName: string): boolean {
        let user = AuthenticationService.getUser();
        if (!user)return false;
        if (user.authorities.indexOf('ROLE_ADMIN') != -1) {
            return true;
        }
        return user.authorities.indexOf('ROLE_' + roleName) != -1;

    }

    getStartUrl(): string {
        if (AuthenticationService.isLoggedIn()) {
            return '/search'
        }
        return '/login';
    }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/odQvAFzU/0/heba/118365/src/main/frontend/src/app/_services/authentication.service.ts